// Cookies button

export default class CookiesPopin {
    constructor() {
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            cookiesBtn: document.getElementById("cookies-btn")
        }
    }

    listen() {
        this.ui.cookiesBtn.addEventListener("click", () => {
            Didomi.preferences.show();
        });
    }
}